import {
  columnDefs as userReportsColumnDefs,
  columnDefsFunctions as userReportsColumnDefsFns,
} from "../../apps/users/UserReportsConstants";
import {
  columnDefs as productReportsColumnDefs,
  columnDefsFunctions as productReportsColumnDefsFns,
} from "../../apps/products/ProductsConstants";
import { columnDefs as retailerRportsColumnDefs } from "../../apps/retailer/RetailerReportsConstants";

import { isEmpty } from "../../utils/utils";

const COLUMN_DEFS = {
  user: {
    defs: userReportsColumnDefs,
    defs_fn: userReportsColumnDefsFns,
  },
  product: {
    defs: productReportsColumnDefs,
    defs_fn: productReportsColumnDefsFns,
  },
  branch: {
    defs: retailerRportsColumnDefs,
    // defs_fn: retailerReportsColumnDefsFns,
  },
};

export const fetchColumnDefs = (identifier) => {
  return COLUMN_DEFS[identifier]?.defs;
};

export const fetchColumnDefsFns = (identifier) => {
  return COLUMN_DEFS[identifier]?.defs_fn || [];
};

export const createFilterParam = (
  fieldName,
  fieldValue,
  fieldType,
  operation
) => {
  if (isEmpty(fieldName) || isEmpty(fieldValue)) {
    console.error("fieldName or fieldValue is empty");
    return null;
  }
  let param = { fieldName };
  if (fieldType) {
    param = { ...param, fieldType: { type: fieldType, operation } };
    if (operation === "between") {
      if (!fieldValue?.start || !fieldValue?.end) {
        console.error(
          "start and end in fieldValue is mandatory when operation is between"
        );
        return null;
      }
      param = { ...param, start: fieldValue.start, end: fieldValue.end };
      return param;
    }
  }
  param = { ...param, fieldValue };
  return param;
};
